// extracted by mini-css-extract-plugin
module.exports = {"create":"search_create__GztB1","otherFilters":"search_otherFilters__S_eMi","selection":"search_selection__0MMki","action":"search_action__KDvAM","title":"search_title__8PyMk"};